




















import { Component, Vue } from 'vue-property-decorator'
import { inject } from 'inversify-props'
import AppChangelog from '@core/components/AppChangelog.vue'
import API from '@core/services/API'

@Component({
  components: {
    AppChangelog
  }
})
export default class Changelog extends Vue {
  @inject()
  protected $api: API

  protected activeTab = 'frontend'

  protected faChangelog = []
  protected frontendChangelog = []

  async loadJSON () {
    try {
      this.frontendChangelog = require('@/config/changelog.json').changeLog
    } catch (error) {
      console.error(error)
    }
  }

  async fetchData () {
    const response = await this.$api.changelog.getFA()
    this.faChangelog = response.data
  }

  async mounted () {
    await this.loadJSON()
    await this.fetchData()
  }
}
